import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "flex h-16 justify-between" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8" }
const _hoisted_5 = { class: "hidden lg:block" }
const _hoisted_6 = { class: "block lg:hidden" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "hidden sm:ml-6 sm:flex sm:items-center" }
const _hoisted_9 = { class: "flex flex-col gap-1" }
const _hoisted_10 = { class: "text-gray-500 text-sm inline-flex items-center gap-x-3" }
const _hoisted_11 = { class: "bg-royal-blue-500 text-white rounded-full group-hover:bg-royal-blue-600 p-0.5 text-xs font-semibold" }
const _hoisted_12 = { class: "w-full bg-gray-200 h-1.5 rounded outline outline-1 outline-gray-100" }
const _hoisted_13 = { class: "shrink-0" }
const _hoisted_14 = { class: "relative size-10" }
const _hoisted_15 = {
  class: "size-full -rotate-90",
  viewBox: "0 0 36 36",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_16 = ["stroke-dashoffset"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "sr-only" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "-mr-2 flex items-center gap-2 sm:hidden" }
const _hoisted_21 = { class: "sr-only" }
const _hoisted_22 = { class: "space-y-1 pt-2 pb-3" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "border-t border-gray-200 pt-4 pb-3" }
const _hoisted_25 = { class: "flex items-center px-4" }
const _hoisted_26 = { class: "shrink-0" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "ml-3" }
const _hoisted_29 = { class: "text-base font-medium text-gray-800" }
const _hoisted_30 = { class: "mt-3 px-4" }
const _hoisted_31 = { class: "flex flex-col gap-1" }
const _hoisted_32 = { class: "text-gray-500 text-sm inline-flex items-center gap-x-3" }
const _hoisted_33 = { class: "bg-royal-blue-500 text-white rounded-full group-hover:bg-royal-blue-600 p-0.5 text-xs font-semibold" }
const _hoisted_34 = { class: "w-full bg-gray-200 h-1.5 rounded outline outline-1 outline-gray-100" }
const _hoisted_35 = { class: "mt-3 space-y-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Bars3Icon = _resolveComponent("Bars3Icon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!

  return (_openBlock(), _createBlock(_component_Disclosure, {
    as: "nav",
    class: "fixed top-0 left-0 right-0 z-50 border-b border-gray-200 bg-white sm:bg-white/80 sm:backdrop-filter sm:backdrop-blur-lg shadow-xs"
  }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "flex shrink-0 items-center"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  class: "block h-8 w-auto lg:hidden",
                  src: _imports_0,
                  alt: "Gallera"
                }, null, -1),
                _createElementVNode("img", {
                  class: "hidden h-8 w-auto lg:block",
                  src: _imports_0,
                  alt: "Gallera"
                }, null, -1)
              ])),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.name
                }, [
                  (item.routeName !== false)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: item.href,
                        class: _normalizeClass([(item.routeName !== false && _ctx.isCurrentRoute(item.routeName))
                                    ? 'border-royal-blue-600 text-midnight-950'
                                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                    'relative inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium'
                                ]),
                        "aria-current": (item.routeName !== false && _ctx.isCurrentRoute(item.routeName)) ? 'page' : undefined
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(item.short_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class", "aria-current"]))
                    : _createCommentVNode("", true),
                  (!item.routeName)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: item.href,
                        target: "_blank",
                        class: _normalizeClass([
                                    'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                    'hidden lg:inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium'
                                ])
                      }, _toDisplayString(item.name), 9, _hoisted_7))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: "/subscription",
              class: "hidden md:block shrink-0 mr-3 group hover:opacity-90"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.storageUsed), 1),
                      _createTextVNode(" / " + _toDisplayString(_ctx.storageLimit), 1)
                    ]),
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_PlusIcon, {
                        class: "size-3",
                        "aria-hidden": "true"
                      })
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_12, [
                    _createElementVNode("span", {
                      class: _normalizeClass([{
                                      'bg-yellow-500': _ctx.storageUsedPercent >= 90 && _ctx.storageUsedPercent < 100,
                                      'bg-red-500': _ctx.storageUsedPercent >= 100,
                                      'bg-royal-blue-500': _ctx.storageUsedPercent < 90
                                    }, "h-full rounded block"]),
                      style: _normalizeStyle({ width: `${Math.min(_ctx.storageUsedPercent, 100)}%` })
                    }, null, 6)
                  ])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCreateGallery && _ctx.openCreateGallery(...args)), ["prevent"])),
                class: "relative inline-flex items-center gap-x-1.5 mr-3 rounded-md bg-royal-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royal-blue-500"
              }, [
                _createVNode(_component_PlusIcon, {
                  class: "-ml-0.5 size-5",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('navigation.create_gallery')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(), _createElementBlock("svg", _hoisted_15, [
                _cache[5] || (_cache[5] = _createElementVNode("circle", {
                  cx: "18",
                  cy: "18",
                  r: "16",
                  fill: "none",
                  class: "stroke-current text-gray-200",
                  "stroke-width": "2"
                }, null, -1)),
                _createElementVNode("circle", {
                  cx: "18",
                  cy: "18",
                  r: "16",
                  fill: "none",
                  class: "stroke-current text-royal-blue-500",
                  "stroke-width": "2",
                  "stroke-dasharray": "100",
                  "stroke-dashoffset": 100 - Math.min(_ctx.storageUsedPercent, 100),
                  "stroke-linecap": "round"
                }, null, 8, _hoisted_16)
              ])),
              _createVNode(_component_Menu, {
                as: "div",
                class: "absolute top-1/2 left-1/2 transform w-full p-1 -translate-y-1/2 -translate-x-1/2"
              }, {
                default: _withCtx(() => [
                  (_ctx.isLoggedIn && _ctx.user)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_MenuButton, { class: "relative flex rounded-full bg-white text-sm focus:outline-hidden" }, {
                          default: _withCtx(() => [
                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "absolute -inset-1.5" }, null, -1)),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('navigation.user_menu')), 1),
                            _createElementVNode("img", {
                              class: "size-8 rounded-full",
                              src: _ctx.user.avatar_url,
                              alt: ""
                            }, null, 8, _hoisted_19)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-200",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MenuItems, { class: "absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 ring-1 shadow-lg ring-black/5 focus:outline-hidden" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MenuItem, { class: "border-b border-royal-blue-600" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: "/subscription",
                                class: "block px-4 py-2 text-sm text-royal-blue-600"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.storageUsed), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('navigation.storage_of')) + " " + _toDisplayString(_ctx.storageLimit), 1)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userNavigation, (item) => {
                            return (_openBlock(), _createBlock(_component_MenuItem, {
                              key: item.name
                            }, {
                              default: _withCtx(({ active }) => [
                                _createVNode(_component_router_link, {
                                  to: item.href,
                                  class: _normalizeClass([active ? 'bg-gray-100 outline-hidden' : '', 'block px-4 py-2 text-sm text-gray-700'])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "class"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_MenuItem, null, {
                            default: _withCtx(({ active }) => [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doLogout && _ctx.doLogout(...args)), ["prevent"])),
                                class: _normalizeClass([active ? 'bg-gray-100 outline-hidden' : '', 'block w-full px-4 py-2 text-left text-sm text-gray-700 cursor-pointer'])
                              }, _toDisplayString(_ctx.$t('navigation.logout')), 3)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCreateGallery && _ctx.openCreateGallery(...args)), ["prevent"])),
              class: "relative inline-flex items-center gap-x-1 justify-center rounded-md bg-white px-2.5 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:ring-2 focus:ring-royal-blue-600 focus:ring-offset-2 focus:outline-hidden shadow-xs"
            }, [
              _createVNode(_component_PlusIcon, {
                class: "size-4",
                "aria-hidden": "true"
              }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('navigation.create_gallery')), 1)
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "h-6 w-px bg-gray-300" }, null, -1)),
            _createVNode(_component_DisclosureButton, { class: "relative inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:ring-2 focus:ring-royal-blue-600 focus:ring-offset-2 focus:outline-hidden" }, {
              default: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "absolute -inset-0.5" }, null, -1)),
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('navigation.open_main_menu')), 1),
                (!open)
                  ? (_openBlock(), _createBlock(_component_Bars3Icon, {
                      key: 0,
                      class: "block size-6",
                      "aria-hidden": "true"
                    }))
                  : (_openBlock(), _createBlock(_component_XMarkIcon, {
                      key: 1,
                      class: "block size-6",
                      "aria-hidden": "true"
                    }))
              ]),
              _: 2
            }, 1024)
          ])
        ])
      ]),
      (_ctx.isLoggedIn && _ctx.user)
        ? (_openBlock(), _createBlock(_component_DisclosurePanel, {
            key: 0,
            class: "sm:hidden"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCreateGallery && _ctx.openCreateGallery(...args)), ["prevent"])),
                  class: "border-transparent text-royal-blue-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-800 block border-l-4 py-2 pr-4 pl-3 text-base font-medium"
                }, _toDisplayString(_ctx.$t('navigation.create_gallery')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navigation, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.name
                  }, [
                    (item.routeName)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: item.href
                        }, {
                          default: _withCtx(({ href, navigate }) => [
                            _createVNode(_component_DisclosureButton, {
                              as: "a",
                              href: href,
                              onClick: navigate,
                              class: _normalizeClass([(item.routeName !== false && _ctx.isCurrentRoute(item.routeName)) ? 'border-royal-blue-500 bg-royal-blue-50 text-royal-blue-500' : 'border-transparent text-midnight-950 hover:border-gray-300 hover:bg-gray-50 hover:text-midnight-800', 'block border-l-4 py-2 pr-4 pl-3 text-base font-medium']),
                              "aria-current": (item.routeName !== false && _ctx.isCurrentRoute(item.routeName)) ? 'page' : undefined
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["href", "onClick", "class", "aria-current"])
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (!item.routeName)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: item.href,
                          target: "_blank",
                          class: _normalizeClass(['border-transparent text-midnight-950 hover:border-gray-300 hover:bg-gray-50 hover:text-midnight-800', 'block border-l-4 py-2 pr-4 pl-3 text-base font-medium'])
                        }, _toDisplayString(item.name), 9, _hoisted_23))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("img", {
                      class: "size-10 rounded-full",
                      src: _ctx.user.avatar_url,
                      alt: ""
                    }, null, 8, _hoisted_27)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.user.name), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, [
                      _createElementVNode("span", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.storageUsed), 1),
                        _createTextVNode(" / " + _toDisplayString(_ctx.storageLimit), 1)
                      ]),
                      _createElementVNode("span", _hoisted_33, [
                        _createVNode(_component_PlusIcon, {
                          class: "size-3",
                          "aria-hidden": "true"
                        })
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_34, [
                      _createElementVNode("span", {
                        class: _normalizeClass([{
                                  'bg-yellow-500': _ctx.storageUsedPercent >= 90 && _ctx.storageUsedPercent < 100,
                                  'bg-red-500': _ctx.storageUsedPercent >= 100,
                                  'bg-royal-blue-500': _ctx.storageUsedPercent < 90
                                }, "h-full rounded"]),
                        style: _normalizeStyle({ width: `${Math.min(_ctx.storageUsedPercent, 100)}%` })
                      }, null, 6)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userNavigation, (item) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: item.name,
                      to: item.href
                    }, {
                      default: _withCtx(({ href, navigate }) => [
                        _createVNode(_component_DisclosureButton, {
                          as: "a",
                          href: href,
                          onClick: navigate,
                          class: "block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["href", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128)),
                  _createVNode(_component_DisclosureButton, {
                    as: "a",
                    href: "#",
                    onClick: _withModifiers(_ctx.doLogout, ["prevent"]),
                    class: "block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('navigation.logout')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}